import { isoMiles } from "../../models/nominals";
import { RetailState } from "./models";

export const defaults: Readonly<RetailState> = {
    storesLoadedKey: "",
    stores: [],
    storeFilters: {
        limit: 500,
        distance: isoMiles.wrap(10),
        category: null,
        retailerName: [],
    },
    focusedStoreID: null,
};
